// Types
import {
  AssociatedAlert,
  AssociatedCase,
  AssociatedSAR,
  FullAlertResponse,
} from 'app/modules/alerts/types';
import { ShortEntityResponse } from 'app/modules/entities/responses';
import { ShortTxnResponse } from 'app/modules/transactions/types';
import { ShortInstrumentResponse } from 'app/modules/instruments/responses';

// Models
import { AlertTableType } from 'app/modules/alerts/columns';
import { AlertActionEventResponse } from 'app/modules/alerts/types/responses';

export enum AlertsActionTypes {
  RETRIEVE_ALERTS_SUCCESS = '@@alerts/RETRIEVE_ALERTS_SUCCESS',

  RETRIEVE_ALERT = '@@alerts/RETRIEVE_ALERT',
  RETRIEVE_ALERT_SUCCESS = '@@alerts/RETRIEVE_ALERT_SUCCESS',

  RETRIEVE_ALERT_DETAILS_SUCCESS = '@@alerts/RETRIEVE_ALERT_DETAILS_SUCCESS',

  CLEAR_ALERT_ENTITIES = '@@alerts/CLEAR_ALERT_ENTITIES',

  RETRIEVE_ALERT_TRANSACTIONS = '@@alerts/RETRIEVE_ALERT_TRANSACTIONS',
  RETRIEVE_ALERT_TRANSACTIONS_SUCCESS = '@@alerts/RETRIEVE_ALERT_TRANSACTIONS_SUCCESS',

  RETRIEVE_ALERT_ENTITIES = '@@alerts/RETRIEVE_ALERT_ENTITIES',
  RETRIEVE_ALERT_ENTITIES_SUCCESS = '@@alerts/RETRIEVE_ALERT_ENTITIES_SUCCESS',

  CHANGE_ALERT_COMPONENT_STATUS = '@@alerts/CHANGE_ALERT_COMPONENT_STATUS',
  CHANGE_ALERT_COMPONENT_STATUS_SUCCESS = '@@alerts/CHANGE_ALERT_COMPONENT_STATUS_SUCCESS',

  CREATE_ALERT = '@@alerts/CREATE_ALERT',
  CREATE_ALERT_SUCCESS = '@@alerts/CREATE_ALERT_SUCCESS',

  EDIT_ALERT = '@@alerts/EDIT_ALERT',
  EDIT_ALERT_SUCCESS = '@@alerts/EDIT_ALERT_SUCCESS',

  ADD_DOCUMENTS_SUCCESS = '@@alerts/ADD_DOCUMENTS_SUCCESS',
  DELETE_DOCUMENT_SUCCESS = '@@alerts/DELETE_DOCUMENT_SUCCESS',

  RETRIEVE_ALERT_ACTION_EVENTS = '@@alerts/RETRIEVE_ALERT_ACTION_EVENTS',
  RETRIEVE_ALERT_ACTION_EVENTS_SUCCESS = '@@alerts/RETRIEVE_ALERT_ACTION_EVENTS_SUCCESS',
}

export type EntityResolutionTypes =
  | 'FALSE_POSITIVE'
  | 'TRUE_POSITIVE'
  | 'UNRESOLVED'
  | 'WHITELIST_ENTITY';

export type AlertResolutionTypes =
  | 'FALSE_POSITIVE'
  | 'TRUE_POSITIVE'
  | 'UNRESOLVED'
  | 'CLOSED';

/**
 * @deprecated this is the legacy redux type. If not using redux, should use FullAlertResponse
 */
export type AlertDetails = FullAlertResponse & {
  events?: ShortTxnResponse[];
  instruments?: ShortInstrumentResponse[];
  entities?: ShortEntityResponse[];
  action_events?: AlertActionEventResponse;
};

export interface AlertsState {
  alerts: AlertTableType[];
  alert: AlertDetails;
}

export type AlertStatus =
  | 'OPEN'
  | 'CLOSED'
  | 'IN_REVIEW'
  | 'OPEN_SHADOW'
  | 'RULE_VALIDATION';

export enum AlertPages {
  MY_ALERTS = 'MY_ALERTS',
  ADMIN = 'ADMIN',
  QUEUED_ALERTS = 'QUEUED_ALERTS',
}

export type AssociatedObject = AssociatedAlert | AssociatedCase | AssociatedSAR;

export type AssociatedObjectType = 'alert' | 'case' | 'sar';
